import React from 'react'
import { connect } from 'react-redux'
import { fetchCurrentUser } from '../../redux/actions/users'
import { currentUser } from '../../redux/selectors/user'
import PropTypes from 'prop-types'

const withUser = WrappedComp => {
  class UserComp extends React.Component {
    componentDidMount () {
      this.props.fetchCurrentUser()
    }

    render () {
      return <WrappedComp {...this.props} />
    }
  }

  const mapStateToProps = state => {
    return {
      currentUser: currentUser(state)
    }
  }

  const mapDispatchToProps = dispatch => {
    return {
      fetchCurrentUser: () => {
        dispatch(fetchCurrentUser())
      }
    }
  }

  UserComp.propTypes = {
    children: PropTypes.node,
    fetchCurrentUser: PropTypes.func
  }

  return connect(mapStateToProps, mapDispatchToProps)(UserComp)
}

export default withUser
